import { nip19 } from 'nostr-tools';
import { Navigate, useParams } from 'react-router-dom';
import { ProfilePage } from './ProfilePage';
import NotFound from './NotFound';
import { WIKI_ARTICLE_KIND } from '@/lib/nip54';
import { PUBLICATION_INDEX_KIND, PUBLICATION_CONTENT_KIND } from '@/lib/nkbip01';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
      return <ProfilePage pubkey={decoded.data} />;

    case 'nprofile':
      return <ProfilePage pubkey={decoded.data.pubkey} />;

    case 'naddr': {
      const { kind, pubkey, identifier: dTag } = decoded.data;
      const npub = nip19.npubEncode(pubkey);

      // Redirect NIP-54 wiki articles and NKBIP-01 publications/sections
      // addressed via naddr to their canonical Wikistar routes, which
      // carry the author (required to build a secure filter for
      // addressable events — the `d` tag alone is not a trust boundary).
      if (kind === WIKI_ARTICLE_KIND) {
        return <Navigate to={`/w/${encodeURIComponent(dTag)}/${npub}`} replace />;
      }
      if (kind === PUBLICATION_INDEX_KIND) {
        return <Navigate to={`/p/${encodeURIComponent(dTag)}/${npub}`} replace />;
      }
      if (kind === PUBLICATION_CONTENT_KIND) {
        // A bare section has no publication context here — nothing
        // sensible to link to without its parent index's `d` tag.
        return <NotFound />;
      }
      return <NotFound />;
    }

    case 'note':
    case 'nevent':
      // Wikistar doesn't have a generic event viewer — wiki articles and
      // publications are always reached through their dedicated routes.
      return <NotFound />;

    default:
      return <NotFound />;
  }
}
